import { call, put, select } from 'redux-saga/effects';
import { getAvailableEquipment as getAvailableEquipmentAda } from '@bitComponents/adabyron/catalog';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

const normalizeGetAvailableEquipment = (response) => {

  const availableEquipment = response.equips.map(equip => {
    return {
      parentProductOffering: equip.id,
      actualEquipment: {
        id: equip.resourceSpecPAIN.id,
        category: equip.resourceSpecPAIN.resourceCategory.id
      },
      availableEquipment: equip.resourceSpecs.map(resource => {
        return {
          id: resource.id,
          category: resource.resourceCategory.id,
        }
      })
    }
  });
  return availableEquipment;
}

export function* getAvailableEquipment(params) {
  const {
    normalizeHttpErrors,
    reduxUpdate,
  } = params;
  try {
    const context = yield select(contextStore);
    const response = yield call(getAvailableEquipmentAda, context);
    const normalizedResponse = normalizeGetAvailableEquipment(response);
    return normalizedResponse;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GET_AVAILABLE_EQUIPMENT, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }
    throw error;
  }
}
